import { Icon, IconComponent } from '@graftcode/design-system'

import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import { EnterKeyShortcutIcon } from './EnterKeyShortcutIcon'

import styles from '../SearchModal.module.scss'

export function SearchFooter() {
  return (
    <footer className={styles.stickyFooter} data-testid={SEARCH_MODAL_TEST_IDS.footer}>
      <nav aria-label="Keyboard shortcuts for search modal" className={styles.keyboardHints}>
        <div className={styles.keyboardHintLabel}>
          <kbd className={styles.kbdChip}>
            <IconComponent icon={Icon.ArrowDownFilled} size={16} />
          </kbd>
          <kbd className={styles.kbdChip}>
            <IconComponent icon={Icon.ArrowUpFilled} size={16} />
          </kbd>
          <span>Move</span>
        </div>
        <div className={styles.keyboardHintLabel}>
          <kbd className={styles.kbdChip}>
            <EnterKeyShortcutIcon />
          </kbd>
          <span>Select</span>
        </div>
        <div className={styles.keyboardHintLabel}>
          <kbd className={styles.kbdChip}>ESC</kbd>
          <span>Quit</span>
        </div>
      </nav>
    </footer>
  )
}
